import React, { useEffect, useState } from "react";
import PageHeading from "../common/PageHeading";
import {
	Facebook,
	Instagram,
	LinkedIn,
	Necklace,
	Phone,
	Pinterest,
	TikTok,
	Twitter,
	User,
	Whatsapp,
	Youtube,
} from "../../utils/SvgComponents";
import ModalBox from "../common/ModalBox";
import CustomButton from "../common/button/Button";
import CustomCard from "../common/card/Card";
import { apiHandler } from "../../utils/apiHandler";
import { useParams } from "react-router-dom";
import { EVENT_BASEURL, LOGIN_DATA } from "../../utils/Constants";
import { motion } from "framer-motion";
import { getDataFromStore } from "../../utils/CookiesUtils";


const modalDataObj = {
	title: "",
	name: "",
	bgImg: "",
};



const WeddingPartners = () => {
	const { id } = useParams();
	const [response, setResponse] = useState([]);
	const [showMobileModal, setShowMobileModal] = useState(false);
	const [modalData, setModalData] = useState(modalDataObj);
	const [isSticky, setIsSticky] = useState(false);
	const [isBlurred, setIsBlurred] = useState(true);
	const isMobileDevice = /Mobi|Android/i.test(navigator.userAgent);
	const [response1, setResponse1] = useState([]);
	let animationFrameId = null;
	let username = "";

	let NewUsername = "";

	const pathArray = window.location.pathname.split("/").filter(Boolean);

	if (pathArray.includes("Login")) {
		// Handle special case when URL contains "Login"
		NewUsername = pathArray[1];
	} else {
		NewUsername = pathArray[0]
	}

	let data = JSON.parse(localStorage.getItem(`logindata_${NewUsername}`))
	const newImgUrl = `https://welcometowedding.com/events/${data?._id}/`
	console.log(newImgUrl);


	//let data = JSON.parse(localStorage.getItem(`logindata_${username}`))
	console.log(data);
	const eventOwner = data?.eventOwner;
	useEffect(() => {
		const fetchSelfAboutUs = async () => {
			try {
				const res = await apiHandler.post("/admin/aboutus/fetchBranding", {
					eventOwner: eventOwner,
				});
				if (res) {
					setResponse1(res.data);
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};
		if (!isMobileDevice) {
			fetchSelfAboutUs();
		}
	}, [])

	useEffect(() => {
		if (response?.length > 0 && response1?.length > 0) {
			setIsBlurred(false)
		}
	}, [response1, response])
	useEffect(() => {
		const fetchMemories = async () => {
			try {
				const res = await apiHandler.post("/guest/fetch-feature", {
					_id: id,
					category: "WeddingPartner"
				});
				console.log(res);
				if (res && res.partners) {
					const transformedData = res.partners.map(item => ({
						title: item.partnerType,
						name: item.vendorName,
						bgImg: `${newImgUrl + item.bgImg}`,
						facebook: item.facebook || "",
						instagram: item.instagram || "",
						whatsapp: `https://wa.me/${item.whatsapp}` || "",
						youtube: item.youtubeLink || "",
					}));

					setResponse(transformedData);
				}
			} catch (err) {
				console.error("Guest login error:", err);
			}
		};

		fetchMemories();
	}, [])

	useEffect(() => {
		// Unblur after 1 second (adjust delay as needed)
		const timer = setTimeout(() => {
			setIsBlurred(false);
		}, 150);

		// Cleanup timer on unmount
		return () => clearTimeout(timer);
	}, [response]);
	useEffect(() => {
		const handleScroll = () => {
			if (animationFrameId) {
				cancelAnimationFrame(animationFrameId);
			}
			animationFrameId = requestAnimationFrame(() => {
				const outerElement = document.querySelector('.scroll-bar');
				if (outerElement) {
					const scrollPosition = outerElement.scrollTop;
					setIsSticky(scrollPosition > 0);
				}
			});
		};

		const outerElement = document.querySelector('.scroll-bar');
		if (outerElement) {
			outerElement.addEventListener('scroll', handleScroll);
			handleScroll(); // Initial check

			return () => {
				outerElement.removeEventListener('scroll', handleScroll);
				if (animationFrameId) {
					cancelAnimationFrame(animationFrameId);
				}
			};
		}
	}, []);

	useEffect(() => {
		const handlePopState = (event) => {
			console.log("Browser back button was pressed");
			if (showMobileModal) {
				setShowMobileModal(false);
			}
		};

		window.addEventListener("popstate", handlePopState);

		return () => {
			window.removeEventListener("popstate", handlePopState);
		};
	}, [showMobileModal]);


	const openMobileModal = (item) => {
		setModalData(item);
		setShowMobileModal(true);
		window.history.pushState({ modalOpen: true }, "");
	};
	const containerVariants = {
		hidden: {},
		show: {
			transition: {
				staggerChildren: 0.2,
			},
		},
	};

	const itemVariants = {
		hidden: { opacity: 0, y: 30 },
		show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
	};

	let newUrl = ''

	if (response1?.selfBranding) {
		newUrl = 'https://admin.welcometowedding.com/branding/'
	}
	else {
		newUrl = 'https://admin.welcometowedding.com/service/'
	}
	let backImgurl = newUrl + (response1?.userBgImg?.replace(/ /g, "%20"))
	let logoUrl = newUrl + (response1?.userLogo?.replace(/ /g, "%20"))
	const tagline = response1?.tagline || "";

	// how many characters before breaking?
	const breakAfter = 29;

	const firstLine = tagline.slice(0, breakAfter);
	const secondLine = tagline.slice(breakAfter);

	console.log(response1)
	return (
		<div className="" style={{ zIndex: '333333', backgroundColor: 'white' }}>
			<div className="hidden sm:block h-screen overflow-hidden">
				<div className="grid grid-cols-12">
					<div className="col-span-5 relative h-full overflow-hidden text-center">

						{/* Blur → Clear Animated Background */}
						{response1?.userBgImg && <img
							src={backImgurl}
							onLoad={() => setIsBlurred(false)}
							className={`
				w-full h-full object-cover absolute inset-0 
				transition-all duration-[1200ms] ease-out 
				${!isBlurred ? "blur-0 scale-100 opacity-100" : "blur-xl scale-105 opacity-0"}
			`}
							alt=""
						/>}

						{/* Black gradient overlay */}
						<div className="absolute inset-0 bg-black/50 flex flex-col justify-between items-center z-10">

							{/* CENTER CONTENT */}
							<div className="h-full flex flex-col justify-center items-center">

								{/* LOGO */}
								<div className="rounded-full overflow-hidden grid place-items-center pointer-events-none">
									{response1?.userLogo && <img
										src={logoUrl}
										onLoad={() => setIsBlurred(false)}
										className={`
				w-[188px] h-[188px] object-cover
				transition-all duration-[1200ms] ease-out
				${!isBlurred ? "blur-0 scale-100 opacity-100" : "blur-xl scale-105 opacity-0"}
				
			`}
										alt=""
									/>}
								</div>

								{/* BRANDING NAME */}
								<div className="text-white capitalize text-[37px] font-medium py-[15px] tracking-[1.2px]">
									{response1?.brandingName}
								</div>

								{/* LINES */}
								<div className="text-white text-[20px] leading-[35px]">
									{firstLine} <br />
									{secondLine}
								</div>

								{/* CONTACT INFO */}
								<div className="text-white text-[25px] flex flex-col items-center pt-[15px] gap-3">
									<div className="flex items-center font-medium gap-2">
										<User width="25" fill="white" /> {response1?.contactName}
									</div>
									<div className="flex items-center font-medium gap-2">
										<Phone width="25" fill="white" /> {response1?.contactNumber}
									</div>
								</div>
							</div>

							{/* SOCIAL ICONS */}
							<div className="flex flex-col justify-center items-center gap-3 pb-[30px]">
								<div className="text-white capitalize text-[20px]">
									Follow Us On Social Media
								</div>

								<div className="flex justify-center items-center gap-[23px] p-3">

									{response1?.instaLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.instaLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<Instagram width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.fbLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.fbLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<Facebook width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.ybLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.ybLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<Youtube width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.waLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={`https://wa.me/${response1?.waLink}`} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<Whatsapp width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.linkedInLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.linkedInLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<LinkedIn width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.pinterestLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.pinterestLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<Pinterest width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.tiktokLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.tiktokLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<TikTok width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

									{response1?.twitterLink && (
										<div className="rounded-full border-2 border-white bg-black/65 overflow-hidden">
											<a href={response1?.twitterLink} target="_blank" rel="noopener noreferrer">
												<CustomButton>
													<div className="p-2">
														<Twitter width="35" fill="white" />
													</div>
												</CustomButton>
											</a>
										</div>
									)}

								</div>
							</div>
						</div>
					</div>
					<div className="col-span-7">
						<div className="h-screen overflow-x-auto scroll-bar">
							<div className={`m-0 py-2 w-full w-full stickynav ${isSticky ? "isSticky" : "hideinmobile"}`} style={{ position: 'sticky', top: 0, zIndex: '1', backgroundColor: 'white', textAlign: 'center' }}>
								<PageHeading title={"Wedding Partners"} />
							</div>
							<motion.div
								className="flex flex-col gap-[30px]  "
								variants={containerVariants}
								initial="hidden"
								animate="show"
							>
								<div className="grid grid-cols-2 mt-[16px] px-[15px] ">

									{response.map((item, i) => (
										<motion.div
											key={i}
											variants={itemVariants}
											className="   items-start whiteripple cursor-pointer"
										>
											<div
												key={i}
												className="background bg-center rounded-[10px] h-[180px] m-[16px] overflow-hidden flex flex-col justify-between main-card cursor-pointer relative"
											>
												{/* Background Image Layer */}
												<div
													className="absolute inset-0 bg-center bg-cover transition-all duration-500"
													style={{
														backgroundImage: `url(${item.bgImg})`,
														filter: isBlurred ? "blur(10px)" : "none",
														transform: "scale(2.22)", // Default zoom
													}}
												></div>

												{/* Overlay Content Layer */}
												<span className="relative z-10 h-full bg-black/40 newbackground flex flex-col justify-between">
													<div className="h-full flex flex-col justify-center items-center gap-[10px] hideme2">
														<Necklace fill="white" width="60" height="60" />
														<div className="text-white font-semibold text-xl mb-6">
															{item.title}
														</div>
													</div>
													<div className="h-full flex justify-center items-center gap-[20px] hideme">
														{item?.facebook && <a href={`${item.facebook}`} target="_blank" rel="noopener noreferrer"><Facebook width="38" height='38' fill='white' /></a>}
														{item?.instagram && <a href={`${item.instagram}`} target="_blank" rel="noopener noreferrer"><Instagram width="38" height='38' fill='white' /></a>}
														{item?.youtube && <a href={`${item.youtube}`} target="_blank" rel="noopener noreferrer"><Youtube width="38" height='38' fill='white' /></a>}
														{item?.whatsapp && <a href={`${item.whatsapp}`} target="_blank" rel="noopener noreferrer"><Whatsapp width="38" height='38' fill='white' /></a>}
													</div>
												</span>

												{/* Bottom Name Layer */}
												<div className="flex items-end bg-black/40" style={{ zIndex: 20 }}>
													<div className="w-full text-center bg-white/70 py-2 font-medium">
														{item.name}
													</div>
												</div>
											</div>

										</motion.div>
									))}
								</div>
							</motion.div>
						</div>
					</div>
				</div>
			</div>
			<div className="block sm:hidden bg-black h-svh overflow-x-auto pt-2 ">
				<motion.div
					className="flex flex-col gap-[30px]  "
					variants={containerVariants}
					initial="hidden"
					animate="show"
				>
					<div>
						{response.map((item, i) => (
							<motion.div
								key={i}
								variants={itemVariants}
								className="items-start whiteripple cursor-pointer"
							>
								<div
									className="relative m-2 rounded-[10px] h-[180px] mb-4 overflow-hidden flex flex-col justify-between"
									onClick={() => openMobileModal(item)}
								>
									{/* Background image layer */}
									<div
										className="absolute inset-0 bg-cover bg-center"
										style={{
											backgroundImage: `url(${item.bgImg})`,
											filter: isBlurred ? "blur(10px)" : "none",
											transition: "filter 1s ease-in-out", // smooth unblur/blur
										}}
									></div>

									{/* Optional dark overlay */}
									<div className="absolute inset-0 bg-black/40"></div>

									{/* Main content on top */}
									<div className="relative z-10 h-full flex flex-col justify-center items-center gap-[10px]">
										<Necklace fill="white" width="60" height="60" />
										<div className="text-white font-semibold text-xl">
											{item.title}
										</div>
									</div>

									{/* Bottom label */}
									<div className="relative z-10 flex items-end">
										<div className="w-full text-center bg-white/70 py-2 font-medium">
											{item.name}
										</div>
									</div>
								</div>
							</motion.div>
						))}
					</div>
				</motion.div>
			</div>

			<ModalBox
				show={showMobileModal}
				toggleModel={() => {
					setShowMobileModal(false)
					window.history.back();
				}}
				modalClass={"sliderBlockModal  outline-none "}
				closeTimeoutMS={200}
			>
				<div className="modal-content  bg-purple border-none " style={{ perspective: 'none' }}>
					<div
						className="modal-body  "
						style={{ backgroundImage: `url(${modalData.bgImg})` }}
					>
						<div className="h-full bg-black/40 flex flex-col justify-center items-center gap-[10px] py-[1rem] ">
							<Necklace fill="white" width="60" height="60" />
							<div className="text-white font-semibold text-xl">
								{modalData.title}
							</div>
						</div>
						<div className="flex items-end bg-black/40">
							<div className="w-full text-center bg-white/70 py-2 font-medium">
								{modalData.name}
							</div>
						</div>
					</div>
					<div className="bg-white flex justify-center gap-6 px-2 py-2">
						{modalData?.Phone && (
							<button className="buttonripple">
								<div className="flex flex-col justify-center items-center gap-1">
									<Phone width="28" />
									<div>Phone</div>
								</div>
							</button>
						)}

						{modalData?.whatsapp && (
							<button className="buttonripple">
								<a href={modalData?.whatsapp}
									target="_blank"
									rel="noopener noreferrer"
									className="buttonripple no-underline text-black">
									<div className="flex flex-col justify-center items-center gap-1">
										<Whatsapp width="28" />
										<div>Whatsapp</div>
									</div>
								</a>
							</button>
						)}

						{modalData?.instagram && (
							<button className="buttonripple">
								<a href={modalData?.instagram}
									target="_blank"
									rel="noopener noreferrer"
									className="buttonripple no-underline text-black"
								>
									<div className="flex flex-col justify-center items-center gap-1">
										<Instagram width="28" />
										<div>Instagram</div>
									</div>
								</a>
							</button>
						)}

						{modalData?.facebook && (
							<button className="buttonripple">
								<a href={modalData?.facebook}
									target="_blank"
									rel="noopener noreferrer"
									className="buttonripple no-underline text-black"
								>
									<div className="flex flex-col justify-center items-center gap-1">
										<Facebook width="28" />
										<div>Facebook</div>
									</div></a>
							</button>
						)}
					</div>

				</div>
			</ModalBox>
		</div>
	);
};

export default WeddingPartners;
